import React from "react";
import { Link } from 'react-router-dom';
import './Footer.css';
import logo2 from "../img/logo2-branca.png";
import { INSTAGRAM, FACEBOOK, WHATSAPP_AULA } from '../config';

const LINKS = [
    { hash: '#about', label: 'Sobre' },
    { hash: '#staff', label: 'Treinadores' },
    { hash: '#gallery', label: 'Galeria' },
    { hash: '#class', label: 'Horários' },
    { hash: '#location', label: 'Locais' },
    { hash: '#contact', label: 'Contacto' },
];

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-brand">
                    <img src={logo2} alt="HM Escola de Kickboxing" className="footer-logo" loading="lazy" />
                    <p className="footer-slogan">Formar campeões, inspirar vidas.</p>
                </div>

                <nav className="footer-links" aria-label="Rodapé">
                    <h2 className="footer-heading">Navegação</h2>
                    {LINKS.map(({ hash, label }) => (
                        <Link key={hash} to={{ pathname: '/', hash }}>{label}</Link>
                    ))}
                </nav>

                <div className="footer-links">
                    <h2 className="footer-heading">Redes sociais</h2>
                    <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href={FACEBOOK} target="_blank" rel="noopener noreferrer">Facebook</a>
                    <a href={WHATSAPP_AULA} target="_blank" rel="noopener noreferrer">WhatsApp</a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {new Date().getFullYear()} HM Escola de Kickboxing · Todos os direitos reservados.</p>
            </div>
        </footer>
    );
};

export default Footer;
